module.exports = {"name":"faleComOPrefeito","description":"faleComOPrefeito","organization":"Seção de Sistemas","version":"1.8.0","private":true,"authors":["Antonio Furlaneto <afurlaneto@sorocaba.sp.gov.br>","Victor Bastos <vbastos@sorocaba.sp.gov.br>"],"dependencies":{"bootstrap":"3.3.7","font-awesome":"4.7.0","jquery":"3.1.1","moment":"2.17.1","vue":"^2.2.4","vue-router":"^2.3.0"},"devDependencies":{"eslint":"^3.17.1","eslint-loader":"^1.6.3","eslint-plugin-vue":"^2.0.1","vue-loader":"^11.1.4","vue-template-compiler":"^2.2.4"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 384
// module chunks = 1